module.exports = __webpack_public_path__ + "img/delivery-truck.3ffac4cd.png";